import { render } from "./dialog.vue?vue&type=template&id=5aedf1c8&scoped=true&ts=true"
import script from "./dialog.vue?vue&type=script&lang=ts"
export * from "./dialog.vue?vue&type=script&lang=ts"

import "./dialog.vue?vue&type=style&index=0&id=5aedf1c8&scoped=true&lang=css"

import exportComponent from "/Users/star/Desktop/clz-frontend/taxi-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5aedf1c8"]])

export default __exports__